<template>
  <div>
    <h2>Chatbot, Tell me about you</h2>
    <form class="clean" action="">
      <label for="name">Name</label>
      <input id="name" type="text" v-model="chatUser.user.name"/>
      <label for="email">Email</label>
      <input id="email" type="text" v-model="chatUser.user.email"/>
      <div class="inline">
        <div class="label">Gender</div>
        <input id="gender-male" type="radio" value="male" v-model="chatUser.user.gender"/>
        <label for="gender-male">Male</label>
        <input id="gender-female" type="radio" value="female" v-model="chatUser.user.gender"/>
        <label for="gender-female">Female</label>
      </div>
      <loading-state :state="state">Preparing...</loading-state>
      <button @click="doRegister($event)" v-if="!state.isLoading()"  class="black">Get Start</button>
    </form>
  </div>
</template>
<script>
import { DataState } from '@/state'
import { CricketChatUser } from '@/models/cricket/chatbot'

export default {
  props: {
    'chatUser': Object
  },
  data () {
    return {
      state: DataState.newNotInit()
    }
  },
  methods: {
    doRegister (event) {
      if (event) event.preventDefault()
      this.state.changeToLoading()
      this.chatUser.register().then(chatUser => {
        this.chatUser.updateUserStatus(chatUser)
        CricketChatUser.State.user = this.chatUser
        this.state.changeToLoaded()
      }).catch((error) => {
        console.error(error)
        this.state.changeToError(error)
      })
    }
  }
}
</script>

